export const createMessageAttachment = async ({ file, id, chatId }) => {
    const body = new FormData();
    const { name, lastModified, } = file;
    body.append("id", id);
    body.append("name", name);
    body.append("lastModifiedAt", new Date(lastModified).toISOString());
    if (chatId) {
        body.append("chatId", chatId.toString());
    }
    body.append("file", file);
    return await fetch("/api/assistant/attachments", {
        method: "POST",
        body,
    }).then(async (res) => {
        if (!res.ok) {
            throw new Error("Failed to upload attachment");
        }
        return res.json();
    });
};
